import React from "react";
import '../../App.css'
import Wai262FloraCard from "../Wai262FloraCard";
import Roots from "../Roots";

export default function Wai262Flora(){
    return (
        <>
            <Wai262FloraCard />
            <Roots />
        </>

    )
}